import { device, DEVICE_TYPES } from '../env'
import YAML from 'yaml'

const CONFIG_FILE_PATH = '.env.yml'
let config = {}

export async function load() {
  try {
    const deviceInfo = device()
    if (deviceInfo.type === DEVICE_TYPES.DESKTOP) {
      const fs = require('fs')
      const util = require('util')
      const readFile = util.promisify(fs.readFile)
      if (fs.existsSync(CONFIG_FILE_PATH)) {
        const configYaml = await readFile(CONFIG_FILE_PATH, 'utf8')
        config = YAML.parse(configYaml)
        return true
      }
      return false
    } else {
      // TODO(ngh0818): need to logging
      throw new Error('only support desktop')
    }
  } catch (error) {
    // TODO(ngh0818): need to logging
    return false
  }
}

export function get(key) {
  return config[key]
}

export default {
  load,
  get
}
